// In atlas builds, we want to point to my.securityjourney.dev|com directly
// to avoid CORS issues with the sandbox service.
export const getSandboxUrl = (): string => {
  const origin = window.location.origin;
  if (origin.includes("localhost") || origin.includes("atlas")) {
    const tld = origin.includes(".com") ? "com" : "dev";
    return `https://my.securityjourney.${tld}`;
  } else {
    return origin;
  }
};
